<template>
  <div>
    <div class="cv_list">
      <swiper :options="swiperOptionsVideoAlbum">
        <swiper-slide v-for="(item, index) in videoList[id % 5]" :key="index">
          <div class="cvl_item">
            <div class="cvl_img">
              <a :href="'/old-album?id=' + item.id" target="_blank"
                ><img :src="item.src" alt=""
              /></a>
            </div>
            <div class="cvl_title">{{ item.title }}</div>
          </div>
        </swiper-slide>
      </swiper>
      <div
        class="swiper-button-next album-button-next el-icon-arrow-right"
        slot="pagination"
      ></div>
      <div
        class="swiper-button-prev album-button-prev el-icon-arrow-left"
        slot="pagination"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    id: Number,
  },
  data() {
    return {
      swiperOptionsVideoAlbum: {
        navigation: {
          nextEl: ".album-button-next",
          prevEl: ".album-button-prev",
        },
        slidesPerView: 7,
      },
      videoList: [
        [
          {
            id: "17",
            src: "http://vphoto.kepuchina.cn/images/20191231575350776433_76.jpg",
            title: "美国科学促进会",
          },
          {
            id: "18",
            src: "http://vphoto.kepuchina.cn/images/20178111502417219453_39.jpg",
            title: "麻省理工学院：K12课程",
          },
          {
            id: "19",
            src: "http://vphoto.kepuchina.cn/images/20171091507529127668_39.jpg",
            title: "牛津大学：正确面对艾滋病",
          },
          {
            id: "20",
            src: "http://vphoto.kepuchina.cn/images/20178171502939933022_39.jpg",
            title: "美国航天宇航局（NASA）",
          },
          {
            id: "21",
            src: "http://vphoto.kepuchina.cn/images/20178101502347940977_39.jpg",
            title: "NASA：科学之光",
          },
          {
            id: "22",
            src: "http://vphoto.kepuchina.cn/images/20178101502347930377_39.jpg",
            title: "NASA：美国宇航局的地球时刻",
          },
          {
            id: "23",
            src: "http://vphoto.kepuchina.cn/images/20178101502347874507_39.jpg",
            title: "耶鲁大学：天体物理学之探索和争议",
          },
        ],
        [
          {
            id: "10",
            src: "http://vphoto.kepuchina.cn/images/2021/11/11/202111111636612294969_85.jpg",
            title: "千名医师讲中医",
          },
          {
            id: "11",
            src: "http://vphoto.kepuchina.cn/images/202110151634278691926_85.jpg",
            title: "青少年航天科普教育专家系列录播课",
          },
          {
            id: "12",
            src: "http://vphoto.kepuchina.cn/images/202110111633920809419_85.png",
            title: "“贝多芬新声”耳科科普专题",
          },
          {
            id: "13",
            src: "http://vphoto.kepuchina.cn/images/20219301632969704435_85.jpg",
            title: "《节水总动员》大众版",
          },
          {
            id: "14",
            src: "http://vphoto.kepuchina.cn/images/20219281632801167454_85.jpg",
            title: "《节水总动员》青少版",
          },
          {
            id: "15",
            src: "http://vphoto.kepuchina.cn/images/2021921630564023738_85.jpg",
            title: "2020月亮嘉年华",
          },
          {
            id: "16",
            src: "http://vphoto.kepuchina.cn/images/2021921630553985923_85.jpg",
            title: "幻海寻踪",
          },
        ],
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.cv_list {
  position: relative;
  .cvl_item {
    width: 148px;
    .cvl_img {
      width: 100%;
      //height: px;
      overflow: hidden;
      img {
        width: 100%;
        height: auto;
      }
    }
    .cvl_title {
      padding: 5px 0 16px 0;
      @include fontSize(18px, 400, #353535, 25px);
      @include textoverflow;
    }
  }
  .swiper-container {
    position: relative;
    height: 100%;
  }
  .swiper-slide {
    margin-right: 4px;
  }
  .swiper-button-prev {
    top: 79px !important;
    left: 0 !important;
    width: 28px;
    height: 37px;
    margin-top: 0;
    background: #f4f4f4;
    border-radius: 0 100px 100px 0;
  }
  .swiper-button-next {
    top: 79px !important;
    right: 0 !important;
    width: 28px;
    height: 37px;
    margin-top: 0;
    background: #f4f4f4;
    border-radius: 100px 0 0 100px;
  }
  .swiper-button-prev::after {
    content: " ";
    //margin-left: -6px;
    //font-size: 18px;
    //font-weight: 600;
    //color: #979797;
  }

  .el-icon-arrow-left::before {
    margin-left: -6px;
    font-size: 24px;
    font-weight: 600;
    color: #979797;
  }

  .swiper-button-next::after {
    content: " ";
    //margin-left: 6px;
    //font-size: 18px;
    //font-weight: 600;
    //color: #979797;
  }
  .el-icon-arrow-right::before {
    margin-left: 6px;
    font-size: 24px;
    font-weight: 600;
    color: #979797;
  }
}
</style>
